export type NavigationPath =
  | 'options'
  | 'contacts'
  | 'summary'
  | 'present'
  | 'customer-experience'
  | 'outage-experience'
  | 'capture-media'
  | 'notes'
  | 'follow-up'
  | 'activity'
  | 'send-survey'
  | 'edit-presentation'
  | 'sync-status'
  | 'service-menu'
  | 'financing'
  | 'upgrades'
  | 'documents';

const ROUTE_PATHS = {
  HOME: '/',
  SCHEDULE: '/schedule',
  OFFLINE_DIAGNOSTICS: '/schedule/offline-diagnostics',
  SCHEDULE_SEARCH: '/schedule/search',
  DATA_COLLECTION: '/data-collection',
  PROPOSAL_CUSTOMER_VIEW: '/proposal-customer-view',
  SCHEDULE_DETAIL: (appointmentId: string) => `/schedule/${appointmentId}`,
  APPOINTMENT_PATH: ({
    appointmentId,
    appointmentProposalId,
    path,
    extraPath,
    searchParams,
  }: {
    appointmentId: string;
    appointmentProposalId: string;
    path: NavigationPath;
    extraPath?: string;
    searchParams?: Record<string, string>;
  }) =>
    [
      '/schedule',
      appointmentId,
      'proposal',
      appointmentProposalId,
      path,
      extraPath,
    ]
      .filter(Boolean)
      .join('/') +
    (searchParams ? `?${new URLSearchParams(searchParams)}` : ''),
  PROPOSAL_OPTIONS_PATH: ({
    appointmentId,
    appointmentProposalId,
    appointmentProposalOptionId,
    extraPath,
    searchParams,
  }: {
    appointmentId: string;
    appointmentProposalId: string;
    appointmentProposalOptionId?: string;
    extraPath?: string;
    searchParams?: Record<string, string> | string[][];
  }) =>
    [
      '/schedule',
      appointmentId,
      'proposal',
      appointmentProposalId,
      'options',
      appointmentProposalOptionId,
      extraPath,
    ]
      .filter(Boolean)
      .join('/') +
    (searchParams ? `?${new URLSearchParams(searchParams)}` : ''),
};

export const goBack = () => window.history.back();

export default ROUTE_PATHS;
